// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.operator {
  color: rgb(235, 50, 145);
}

.cursor {
  cursor: pointer;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIm9wZXJhdG9yLWxhYmVsLWFuZC1vci5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQTtFQUNJLHdCQUFBO0FBQUo7O0FBRUE7RUFDSSxlQUFBO0FBQ0oiLCJmaWxlIjoib3BlcmF0b3ItbGFiZWwtYW5kLW9yLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiXG4ub3BlcmF0b3Ige1xuICAgIGNvbG9yOiByZ2IoMjM1LCA1MCwgMTQ1KTtcbn1cbi5jdXJzb3Ige1xuICAgIGN1cnNvcjogcG9pbnRlcjtcbn1cbiJdfQ== */`, "",{"version":3,"sources":["webpack://./projects/app-ui/src/app/admin/components/filter/beautiful-filter/operator-label-and-or/operator-label-and-or.component.scss"],"names":[],"mappings":"AACA;EACI,wBAAA;AAAJ;;AAEA;EACI,eAAA;AACJ;AACA,gbAAgb","sourcesContent":["\n.operator {\n    color: rgb(235, 50, 145);\n}\n.cursor {\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
